export const TURNSTILE_CLOCK_OR_CACHE_ERROR_CODE = "200100"

export const TURNSTILE_EXPECTED_CLIENT_ERROR_PATTERN = /Cloudflare Turnstile.*Error: 200100/i

export const isExpectedTurnstileClientError = (errorCode: string): boolean =>
  errorCode === TURNSTILE_CLOCK_OR_CACHE_ERROR_CODE

export const getTurnstileRecoveryMessage = (retryCount: number): string =>
  retryCount === 0
    ? "Verification could not start. Check your device date and time, then retry."
    : "Verification still could not start. Refresh the page to clear a cached challenge."
